<template>
  <naj-modal-2
    ref="viewRequestModal"
    :title="modelTitle"
    :width="900"
    :footer="true"
    @onClose="closeModal"
  >
    <v-form ref="clarificationForm">
      <v-row>
        <naj-input
          :type-id="formFieldType.textarea"
          :value.sync="request.sentRequestText"
          :label="local.complaints.complaintDetails.clarificationDetails.sendRequestDetails"
          disabled
        ></naj-input>
      </v-row>
      <template v-if="request.responseList && request.responseList.length > 0">
        <v-row v-if="request.requestTypeID == clarificationRequestTypes.clarification">
          <naj-input
            :type-id="formFieldType.textarea"
            :value.sync="request.responseList[0].responseText"
            :label="local.complaints.complaintDetails.clarificationDetails.response"
            :validates="`required`"
            :disabled="viewMode"
          ></naj-input>
        </v-row>
        <v-row v-else>
          <naj-attachment
            :view-mode="viewMode"
            :attachment-list.sync="request.responseList[0].attachmentList"
          >
          </naj-attachment>
        </v-row>
      </template>
    </v-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        v-if="!viewMode"
        @click="submit(closeNajModal)"
      >
        {{ local.common.save }}
      </naj-button>
      <naj-button
        type="button"
        color="error"
        @click="closeModal"
      >
        {{
          local.common.close
        }}
      </naj-button>
    </template>
  </naj-modal-2>
</template>
<script>

import { clarificationRequestTypes } from '@/modules/complaints/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');

export default {
  name: 'ViewInspectorRequestModal',
  components: {},
  props: {
    request: {
      type: Object,
      default: () => { },
    },
    viewMode: {
      type: Boolean,
      default: () => (false),
    },
    modalVisibility: { type: Boolean },
  },
  data() {
    return { clarificationRequestTypes };
  },
  computed: {
    modelTitle() {
      if (this.request.requestTypeID == this.clarificationRequestTypes.clarification)
        return this.local.complaints.complaintDetails.clarificationDetails.clarification;
      else
        return this.local.complaints.complaintDetails.clarificationDetails.clarificationWithAttachment;
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.viewRequestModal.show();
      } else {
        this.$refs.viewRequestModal.close();
      }
    },
  },
  mounted() { },
  methods: {
    ...mapComplaintsActions([
      'addBeneficiaryResponse',
      'addBeneficiaryResponseWithAttachment',
    ]),
    closeModal() {
      this.request.responseList = [{
        attachmentList: [],
        responseDateH: '',
        responseText: '',
      }];
      this.$emit('onClose');
    },
    submit() {
      this.$refs.clarificationForm.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            let methodName = this.addBeneficiaryResponse;
            let payload = {
              requestID: this.request.requestNo,
              details: this.request.responseList[0].responseText,
            };
            if (this.request.requestTypeID == clarificationRequestTypes.addAttachment) {
              methodName = this.addBeneficiaryResponseWithAttachment;
              payload = {
                ...payload,
                attachment: this.request.responseList[0].attachmentList,
              };
            }
            methodName(payload)
              .then(({ data }) => {
                if (data) {
                  this.toaster.success(this.local.complaints.complaintDetails.requestLogInfo.cancelRequestSucceed);
                  this.$emit('onClose');
                  this.$emit('updateComplaint');
                } else {
                  this.toaster.error(this.local.complaints.complaintDetails.requestLogInfo.cancelRequestFail);
                  this.$emit('onClose');

                }
              })
              .finally(() => {
              });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.view-input {
  ::v-deep {
    .v-input {
      &.v-text-field--outlined {
        .v-label {
          font-size: 17px !important;
          color: #34675a !important;
        }

        input,
        textarea {
          color: #34675a;
          max-height: none;
          padding: 0;
          font-size: 16px;
          font-weight: bold;
        }

        .v-input__slot {
          min-height: 36px;
        }
      }

      &.v-text-field--outlined.v-input--is-disabled fieldset {
        padding: 5px;
        background-color: #f7f7f7;
        border-bottom: 1px solid #b69a70;
        font-weight: bold;
        height: auto;
        min-height: 1px;
        border-left: none;
        border-right: none;
        border-top: none;
        border-radius: 0;
      }
    }
  }
}

::v-deep {
  .custom-naj-card.v-card {
    border: 1px solid #dee2e6;
    border-right: 2px solid #b69a70;
    border-left: 2px solid #b69a70;
    border-radius: 0;
    padding: 24px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    box-shadow: none !important;
    p,
    label {
      color: #34675a;
    }
    h4 {
      color: #343a40;
      font-size: 18px;
      margin: 0 0 24px 0;
      .v-icon {
        font-size: 18px;
        color: #343a40;
      }
    }

    .status {
      border-radius: 20px;
      color: white;
      font-size: 12px;
      font-weight: bold;
      float: inline-end;
      padding: 4px 8px;
      &.status-inprogress {
        background-color: #203f39;
      }
      &.status-completed {
        background-color: green;
      }
      &.status-closed {
        background-color: red;
      }
    }
  }
}
</style>
